const themeStyles = {
  colors: {
    white: "#fff",
    gray: "#bbb",
    black: "#171A1D",
    general: "#727272",
    blackSoft: "#333",
    blackCol: "#2e333c",
    blackMore: "#0f0f0f",
    primary: "#5623d8",
    secondary: "#6a79fa",
    tertiary: "#e615af",
    colorMore: "#bc1c1c",
  },

  fonts: {
    titleFont: '"Oxanium", Helvetica, Arial, sans-serif',
    bodyFont: '"Manrope", Helvetica, Arial, sans-serif',
    borderDefault: "solid 1px rgba(30, 30, 30, 1)",
    bodyFontColor: "#757575",
    darkBodyFontColor: "#ADB7BE",
  },

  general: {
    body: {
      fontFamily: "var(--body-font)",
      fontSize: "16px",
      fontWeight: "500",
      color: "var(--body-font-color)",
      background: "var(--bg-dark-1)",
      lineHeight: "30px",
      letterSpacing: "-0.2px",
      overflowX: "hidden",
    },
    transition: "all 0.3s ease",
  },

  margins: {
    mt: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`mt${i * 10}`]: `${i * 10}px` }), {}),
    mb: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`mb${i * 10}`]: `${i * 10}px` }), {}),
    ml: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`ml${i * 10}`]: `${i * 10}px` }), {}),
    mr: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`mr${i * 10}`]: `${i * 10}px` }), {}),
  },

  paddings: {
    pt: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`pt${i * 10}`]: `${i * 10}px` }), {}),
    pb: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`pb${i * 10}`]: `${i * 10}px` }), {}),
    pl: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`pl${i * 10}`]: `${i * 10}px` }), {}),
    pr: [...Array(11).keys()].reduce((acc, i) => ({ ...acc, [`pr${i * 10}`]: `${i * 10}px` }), {}),
  },

  buttons: {
    btnMain: {
      display: "inline-block",
      fontFamily: "var(--title-font)",
      textAlign: "center",
      color: "#fff",
      fontWeight: "bold",
      textTransform: "uppercase",
      padding: "3px 20px 2px 20px",
      fontSize: "14px",
      border: "none",
      borderRadius: "5px",
      transition: "all 0.3s ease",
      hover: {
        boxShadow: "0 0 40px 0px rgba(var(--primary-color-rgb), 1)",
      },
    },
    btnLine: {
      display: "inline-block",
      fontFamily: "var(--title-font)",
      textAlign: "center",
      color: "#fff",
      background: "none",
      fontWeight: "bold",
      textTransform: "uppercase",
      padding: "3px 20px 2px 20px",
      fontSize: "14px",
      border: "solid 2px var(--primary-color)",
      borderRadius: "5px",
      transition: "all 0.3s ease",
      hover: {
        background: "var(--primary-color)",
      },
    },
  },

  navbar: {
    base: {
      width: "100%",
      top: "0",
      left: "0",
      position: "absolute",
      display: "flex",
      alignItems: "center",
      borderBottom: "solid 1px rgba(255, 255, 255, 0)",
      transition: "all 0.3s ease",
    },
    sticky: {
      position: "fixed",
      background: "#1b1b1b",
      transition: "all 0.6s ease",
    },
    menu: {
      display: "flex",
      justifyContent: "flex-end",
      item: {
        counterIncrement: "my-awesome-counter",
      },
    },
  },

  dropdown: {
    base: {
      color: "var(--white)",
      fontSize: "14px",
      position: "relative",
      overflow: "unset !important",
      fontWeight: "600",
      padding: "0 20px 0 0",
      background: "none !important",
    },
    item: {
      width: "190px",
      position: "absolute",
      background: "var(--bg-dark-1)",
      border: "solid 1px rgba(255, 255, 255, .1)",
      padding: "0",
      boxShadow: "2px 2px 30px 0px rgba(20, 20, 20, 0.1)",
    },
  },

  mediaQueries: {
    mobile: {
      "@media (max-width: 992px)": {
        ".navbar": {
          padding: "12px 0",
          background: "var(--bg-dark-1)",
          ".menu": {
            display: "block",
            paddingTop: "30px",
            ".navbar-item": {
              display: "block",
              padding: "10px 0px",
              borderBottom: "1px solid rgba(255, 255, 255, .1)",
            },
          },
        },
      },
    },
    tablet: {
      "@media (max-width: 1199px)": {
        ".desktop": {
          display: "none",
        },
        ".burgerMenu": {
          display: "block",
        },
      },
    },
  },
};

// Function to dynamically update styles
const updateThemeStyles = (key, value) => {
  const keys = key.split(".");
  let obj = themeStyles;

  for (let i = 0; i < keys.length - 1; i++) {
    obj = obj[keys[i]];
  }
  obj[keys[keys.length - 1]] = value;
};

// Example: Update primary color dynamically
updateThemeStyles("colors.primary", "#ff0000");

console.log(themeStyles);
export { themeStyles };
